import { render, staticRenderFns } from "./DisagreementsReportDialog.vue?vue&type=template&id=44d2425e"
import script from "./DisagreementsReportDialog.vue?vue&type=script&lang=ts"
export * from "./DisagreementsReportDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports